import { useEffect, useState } from 'react';
import { api } from '../api.js';

// Invite friends — the keeper's share link (with their referral code)
// plus a native share + copy. Reefkeeping is a word-of-mouth hobby, so
// this lives right in the account sheet. Credits (if enabled) surface
// here later; for now it's a clean, friction-free share.
export function InvitePanel() {
  const [ref, setRef] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let alive = true;
    api('/api/referral')
      .then((r) => alive && setRef(r))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!ref?.url) return null;

  const share = async () => {
    const payload = {
      title: 'TankSensei',
      text: 'I use TankSensei to keep my reef tank healthy — thought you might like it.',
      url: ref.url,
    };
    try {
      if (navigator.share) {
        await navigator.share(payload);
        return;
      }
    } catch {
      /* user cancelled the share sheet — fine */
    }
    copy();
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(ref.url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard blocked — the link is visible to select manually */
    }
  };

  return (
    <div style={{ marginTop: 18 }}>
      <div
        className="font-heading"
        style={{
          fontSize: 12,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: 'var(--text-dim)',
          marginBottom: 6,
        }}
      >
        Invite friends
      </div>
      <p style={{ fontSize: 15, color: 'var(--text-muted)', lineHeight: 1.5, margin: '0 0 10px' }}>
        {ref.program?.enabled && ref.program.reward_copy
          ? ref.program.reward_copy
          : 'Know a reefer who’d like TankSensei? Send them your link.'}
        {ref.joined > 0 ? (
          <>
            {' '}
            <b style={{ color: 'var(--text)' }}>
              {ref.joined} {ref.joined === 1 ? 'friend has' : 'friends have'} joined
            </b>{' '}
            so far.
          </>
        ) : null}
      </p>
      <div
        style={{
          fontSize: 14.5,
          color: 'var(--text-muted)',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          background: 'var(--surface, rgba(127,127,127,.08))',
          border: '1px solid var(--surface-border, rgba(127,127,127,.16))',
          borderRadius: 10,
          padding: '10px 12px',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
        }}
      >
        {ref.url}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button
          type="button"
          onClick={share}
          className="font-heading"
          style={{
            flex: 1,
            minHeight: 44,
            padding: '10px 14px',
            borderRadius: 10,
            fontSize: 13,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            background: 'var(--accent, #e05b3c)',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Share
        </button>
        <button
          type="button"
          onClick={copy}
          className="font-heading"
          style={{
            minHeight: 44,
            padding: '10px 14px',
            borderRadius: 10,
            fontSize: 13,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            background: 'transparent',
            color: 'var(--text)',
            border: '1px solid var(--surface-border, rgba(127,127,127,.2))',
            cursor: 'pointer',
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>

      {ref.credits?.earned_count > 0 ? (
        <div
          style={{
            marginTop: 12,
            padding: '12px 14px',
            borderRadius: 12,
            background: 'var(--surface, rgba(127,127,127,.08))',
            border: '1px solid var(--surface-border, rgba(127,127,127,.16))',
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 700 }}>
            You&rsquo;ve earned {ref.credits.earned_count} {ref.credits.currency_label || 'credit'}
            {ref.credits.earned_count === 1 ? '' : 's'}
          </div>
          <div style={{ fontSize: 14, color: 'var(--text-muted)', margin: '2px 0 8px' }}>
            Redeem at Printed Reef checkout with these codes:
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {ref.credits.coupons.map((c) => (
              <span
                key={c.code}
                style={{
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  fontSize: 14,
                  fontWeight: 600,
                  padding: '4px 9px',
                  borderRadius: 7,
                  background: 'var(--surface-2, rgba(127,127,127,.12))',
                  color: c.status === 'redeemed' ? 'var(--text-dim)' : 'var(--text)',
                  textDecoration: c.status === 'redeemed' ? 'line-through' : 'none',
                }}
              >
                {c.code}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
